import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-lions-light dark:bg-lions-dark">
      <div className="container-custom py-20 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-9xl font-bold text-lions-blue dark:text-lions-yellow mb-4">404</h1>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 dark:text-white">Pagina niet gevonden</h2>
          <p className="text-lg mb-8 text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            De pagina die u probeert te bezoeken bestaat niet of is verplaatst. 
            Ga terug naar de homepage of neem contact met ons op als u hulp nodig heeft.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/" className="btn-primary">
              Terug naar home
            </Link>
            <Link to="/contact" className="btn-secondary">
              Contact opnemen
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound; 